import { GridItem } from '@components/GridItem';
import { HeavyPaper } from '@components/HeavyPaper';
import { VerticalGrid } from '@components/VerticalGrid';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { makeStyles } from '@material-ui/core';
import { RegistrarPagamentoModal } from '@mod/Pagamento/RegistrarPagamentoModal';
import IFatura from '@model/Fatura';
import { useFaturaService } from '@services/FaturaService';
import React from 'react';
import { FaturaAbertaTable } from './FaturaAbertaTable';
import { PagamentoFilter } from './PagamentoFilter';

export enum EnumPagamentoUpdateMode {
    Remove, Update
}

export type HomePagamentoProps = {
    
}

export function HomePagamento (props: HomePagamentoProps) {
    const lastTerm = React.useRef<string>();
    
    const pagamentoData = useData<IFatura>();
    const loading = useLoading();
    const message = useMessage();
    const faturaService = useFaturaService();
    const registrarPagamentoModal = useModalWindow();
    const cls = useStyles();

    const handleSearch = React.useCallback((term?: string) => {
        if (term !== undefined && !loading.isLoading) {
            lastTerm.current = term;

            loading.start();
            faturaService.listarFaturasPorTermo(term)
                .then(pagamentoData.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [faturaService, loading, message.showException, pagamentoData.handleDataResponse]);

    const handlePagamentoRegistrado = React.useCallback((fatura: IFatura, valorRecebido: number, imprimirRecibo: boolean) => {
        handleSearch(lastTerm.current);

        if (imprimirRecibo !== false) {
            fatura.valorPago = valorRecebido;

            const h = JSON.stringify(fatura);
            const hBase64 = btoa(h);
            window.open(`/FaturaRecibo?h=${hBase64}`, "_blank");
        }

    }, [handleSearch]);

    return (
        <React.Fragment>
            <HeavyPaper>
                <VerticalGrid>
                    <GridItem>
                        <PagamentoFilter 
                            onSearch={handleSearch}
                            isLoading={loading.isLoading}
                        />
                    </GridItem>

                    <GridItem>
                        <FaturaAbertaTable
                            isLoading={loading.isLoading} 
                            pagamentoData={pagamentoData}
                            registrarPagamentoModal={registrarPagamentoModal}
                            tableContainerProps={{
                                className: cls.homeTable
                            }}
                        />
                    </GridItem>
                </VerticalGrid>
            </HeavyPaper>

            {
                pagamentoData.focusedRow !== undefined && (
                    <RegistrarPagamentoModal 
                        modal={registrarPagamentoModal}
                        fatura={pagamentoData.focusedRow}
                        onPagamentoRegistrado={handlePagamentoRegistrado}
                    />
                )
            }
        </React.Fragment>
    )
}

const useStyles = makeStyles(theme => ({
    homeTable : {
        height: 'calc(100vh - 180px)'
    }
}));